









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {FormatoArquivoRelatorio} from '@/model/resource/FormatoArquivoRelatorio'
import {InputFormatoArquivoRelatorioSchema} from '@/schema/resource/FormatoArquivoRelatorio/InputFormatoArquivoRelatorioSchema'

@Component
export default class PersistFormatoArquivoRelatorioView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputFormatoArquivoRelatorioSchema()
  formatoArquivoRelatorio = new FormatoArquivoRelatorio()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.formatoArquivoRelatorio.getFormatoArquivoRelatorio(id)
    }

    $.await.done('getFormatoArquivoRelatorio')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.formatoArquivoRelatorio.persistFormatoArquivoRelatorio()
    await Helper.successAndPush(
      'system.success.persist',
      '/formato-arquivo-relatorio/list'
    )
  }
}
